/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-explicit-any */
export const setFieldSilent = (args: any, state: any, utils: any) => {
  const [name, value] = args;

  utils.changeValue(state, name, () => value);

  if (state.initialValues) {
    state.initialValues = {
      ...state.initialValues,
      [name]: value,
    };
  }

  if (!state.fields[name]) {
    state.fields[name] = {
      isEqual: (a: any, b: any) => a === b,
      validators: {},
      asyncValidators: {},
      active: false,
      touched: false,
      visited: false,
    };
  }
};
